import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';

import { setSuperBatchModules } from 'features/moduleManagement';
import Field from 'components/Field';
import SuperBatchModulesTable from '../SuperBatchModulesTable';

function SuperBatchModulesTableRenderer({ superBatchModule }) {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(setSuperBatchModules(superBatchModule));
  }, [dispatch, superBatchModule]);

  return (
    <Field
      label="Modules Present in Core Skills & Curriculum"
      labelClassName="h3"
      className="m-t-s"
    >
      <SuperBatchModulesTable />
    </Field>
  );
}

export default SuperBatchModulesTableRenderer;
